/** Normaliza la clave interna `method_type` (minúsculas, [a-z0-9_], máx. 64). */
export function normalizePaymentMethodTypeKey(raw: string, nameForFallback: string): string {
  const fromRaw = String(raw || '')
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9_]/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 64);
  if (fromRaw.length > 0) return fromRaw;
  return slugFromDisplayName(nameForFallback);
}

export function slugFromDisplayName(name: string): string {
  const base = String(name || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/_+/g, '_')
    .replace(/^_|_$/g, '')
    .slice(0, 48);
  const s = base || 'metodo';
  return s.slice(0, 64);
}
